export default __webpack_public_path__ + "static/media/react_scaled.11087ac7.png";